;
define("product_details_add_to_product_list.tpl", function(){});

